<div class="dialog-class w652">
  <div class="image-header">
    <img src="assets/images/micetribe.svg" alt="" class="tw-h-16" />
    <img [src]="legalRegulator?.logo" alt="" class="tw-h-16" />
  </div>
  <div class="dtcm-message">
    <h3>{{ data?.headerText }}</h3>
    <p class="mb-3">
      Events in {{ data?.city }} are regulated by <span [innerHTML]="legalRegulator?.name"></span>. Before publishing your event, you will need to acquire a
      <strong>{{ legalRegulator?.acronym }}</strong> event permit.<br />
    </p>
    <p class="mb-3">
      <strong>MICEtribe</strong> has partnered with <strong>{{ legalRegulator?.acronym }}</strong> to help you through the process and connect your event registration directly to
      the <strong>{{ legalRegulator?.acronym }}</strong> system.
    </p>
    <ul class="mb-4 tw-list-disc tw-ps-8">
      <li>
        <p>
          If you don't have a <strong>{{ legalRegulator?.acronym }}</strong> event permit yet, <a tabindex="-1" href="{{ legalRegulator?.link }}" target="_blank">click here</a> to
          learn how to get one.
        </p>
      </li>
      @if (legalRegulator?.acronym === 'DET') {
      <li>
        <p>
          Next you will need to choose <strong>Contacless Event Management</strong> as your registration partner and acquire a Performance Report from <strong>DET</strong> which
          includes all what you need to connect your event in <strong>MICEtribe</strong> with the <strong>DET</strong> system.
        </p>
      </li>
      }
      <li>
        <p>
          If you have your Performance Report already <a (click)="proceed(legalRegulator?.acronym)" tabindex="-1">click here</a> to connect your event in
          <strong>MICEtribe</strong> with <strong>{{ legalRegulator?.acronym }}</strong
          >.
        </p>
      </li>
      <li>
        <p>If you need any help with the process, use the chat button below to open a ticket or connect with your dedicated Organizer Success Manager.</p>
      </li>
    </ul>
  </div>
  <div class="buttons">
    <button class="cancel" (click)="proceed('back')">{{ data?.cancelButtonText }}</button>
    <button [class]="data.confirmButtonClass" (click)="proceed(legalRegulator?.acronym)">{{ data?.confirmButtonText }}</button>
  </div>
</div>
